import type {
  Answer,
  QuestionProps,
} from "../../../components/Questionnaire/Section/Question/types";
import { LOCALE_EN_GB } from "../../../constants/constants";
import type { Locale } from "../../../types";
import { toISODate } from "../../../utils";
import { expandPercentageObjectAnswer } from "./expandPercentageObjectAnswer";

export const formatDate = (date: string): string => {
  const [day, month, year] = date.split("/");
  return `${year}-${month}-${day}`;
};

export const formatAnswer = (
  question: QuestionProps,
  answer: Answer,
  locale: Locale = LOCALE_EN_GB,
): string | Record<string, string> => {
  if (question.display?.type === "date") {
    return toISODate(answer as string, locale);
  }

  // Handle percentage questions with object answers
  if (question.display?.type === "percentage_split" && question.name) {
    const expandedAnswers = expandPercentageObjectAnswer(question.name, answer);
    // If we got expanded answers, return them as object, otherwise return as string
    return Object.keys(expandedAnswers).length > 0
      ? expandedAnswers
      : (answer as string);
  }

  // Handle currecy values to strip out commas
  if (question.display?.type === "currency" && typeof answer === "string") {
    return answer.replace(/,/g, "");
  }

  return answer as string;
};
